namespace appn.views.billing.billableUsers {
    class InitArgs {
        billingId: number = 0;
        billingBillableUsers: string = emptyString;
        exportBillableUserRows: string = emptyString;
        exportBillableUserActivityRows: string = emptyString;
    }

    let _initArgs: InitArgs;
    let _dtKeys = ['clients-table', 'activated0', 'deactivated0', 'inactive3', 'inactive6', 'inactive12']
    export let _dts: Array<any> = [];
    let _userDataTable: any = null;
    let totalTables: number = 0;
    let dataTable: any = null;

    export function init(args: InitArgs): void {
        _initArgs = args;

        createDataTables();

        addEvents();
    }

    function createDataTables() {
        dataTable = appn.dataTable.create('.clientsTable', {
            iDisplayLength: 25,
            oLanguage: {
                sInfoEmpty: appn.emptyString
            },
            aaSorting: [[1, 'desc']],
            fnInitComplete: function () {
                appn.dataTable.addSearchPlaceholder(T('Filter results where the Billable Users <b>Client Name, User Id, or Email</b> contains a keyword typed in here'));

                appn.saveMeState.init(function () {
                        dataTable.fnDraw(false);
                    },
                    function () {
                        dataTable.fnDraw(false);

                    }, '.dataTables_filter');
            },
            fnDrawCallback: function() {
                $('.toggleuserlist').off().on('click', function() {
                    if ($(this).hasClass('open')) {
                        $(this).text('show users');
                        $(this).siblings('.userAuditTable').hide();
                        $(this).removeClass('open');
                        appn.dataTable.redrawOnResize();
                        return;
                    }
                    $(this).text('hide users');
                    $(this).siblings('.userAuditTable').show();
                    $(this).addClass('open');
                    appn.dataTable.redrawOnResize();
                });
            }
        });
        _dtKeys.forEach((dt) => {
            const dataTable = appn.dataTable.create(`.${dt}`, {
                sDom: appn.dataTable.genSDom(0, 0, 1),
                iDisplayLength: 25,
                oLanguage: {
                    sInfoEmpty: appn.emptyString
                },
                aaSorting: [[1, 'desc']]
            });
            _dts.push(dataTable);
        })
    }

    /**
     * Taking the class name of the table, this function will find the table and redraw it.
     * The timeout is set to allow for the table to render first.
     * @param className
     */
    function renderTableOnOpen(className: string) {
        const currentTable = getTableByClassName(className);
        setTimeout(function () { currentTable.fnDraw(false); }, 200);
    }

    function getTableByClassName(className: string) {
        return _dts.filter((dt) => (dt['0'] as HTMLElement).classList.contains(className))[0];
    }

    function addEvents() {
        $('#exportUsers').off().on('click', function(event) {
            event.preventDefault();

            appn.ajax.get({
                url: _initArgs.exportBillableUserRows
                    + appn.location.buildQueryString([
                        { name: 'billingId', value: _initArgs.billingId },
                        { name: 'server', value: $('#serverFilter').val() },
                        { name: 'year', value: $('#yearFilter').val() },
                        { name: 'month', value: $('#monthFilter').val() },
                        { name: 'showall', value: $('#ShowAllSelected').is(':checked') }
                    ]),
                done: function() {
                    appn.notifications.updateNotificationTotal();
                }
            });
            ui.showExportConfirmation('Billable Users');
        });

        $('#exportUsersActivity').off().on('click', function(event) {
            event.preventDefault();

            appn.ajax.get({
                url: _initArgs.exportBillableUserActivityRows
                    + appn.location.buildQueryString([
                        { name: 'billingId', value: _initArgs.billingId },
                        { name: 'server', value: $('#serverFilter').val() },
                        { name: 'numberOfMonths', value: $('#exportPeriod').val() },
                        { name: 'showall', value: $('#ShowAllSelected').is(':checked') }
                    ]),
                done: function () {
                    appn.notifications.updateNotificationTotal();
                }
            });
            ui.showExportConfirmation('Billable Users Activity');
        });

        $('#export').on('click', function(event) {
            $('#exportDialog').modal('show');
        });

        $('#activatedUsers').on('click', function(event) {
            $('#activatedUserDialog').modal('show');
            renderTableOnOpen(_dtKeys[1]);
        });

        $('#deactivatedUsers').on('click', function(event) {
            $('#deactivatedUserDialog').modal('show');
            renderTableOnOpen(_dtKeys[2]);
        });

        $('#inactiveUsersThree').on('click', function(event) {
            $('#inactiveThreeUserDialog').modal('show');
            renderTableOnOpen(_dtKeys[3]);
        });

        $('#inactiveUsersSix').on('click', function(event) {
            $('#inactiveSixUserDialog').modal('show');
            renderTableOnOpen(_dtKeys[4]);
        });

        $('#inactiveUsersTwelve').on('click', function(event) {
            $('#inactiveTwelveUserDialog').modal('show');
            renderTableOnOpen(_dtKeys[5]);
        });

        $('#monthFilter').change(function() {
            reloadPage();
        });

        $('#yearFilter').change(function() {
            reloadPage();
        });

        $('#serverFilter').change(function() {
            reloadPage();
        });

        $('#ShowAllSelected').change(function() {
            reloadPage();
        });

        $(document).on('click', '.toggle-user-list', function () {
            const tr = $(this).closest('tr');
            const tableKey = $(this).closest('table').data("table-key") as string;
            const table = getTableByClassName(tableKey);

            if (table.fnIsOpen(tr)) {
                table.fnClose(tr);
                $(this).html(T('show users'));
                return;
            }

            totalTables += 1;
            table.fnOpen(tr, $(tr.find('.users-table-container').html()).addClass('user-table-show_' + totalTables.toString()), 'info_row');
            createUsersDataTable('.user-table-show_' + totalTables.toString(), tableKey);
            $(this).html(T('hide users'));
        });

        $(document).on('click', '.btn-resetFilters', function (e: Event) {
            dataTable.clearSearch();
        });
    }

    function createUsersDataTable(tableClass: string, tableKey: string) {
        if (tableKey == 'activated0' || tableKey.contains('inactive')) {
            // activated & inactive do not need to render Off and Off Reason columns
            _userDataTable = appn.dataTable.create(tableClass, {
                sDom: appn.dataTable.genSDom(0, 0, 0), // sDom empty
                paging: false,
                info: false,
                aaSorting: [[3, 'desc']],
                aoColumns: [
                    { sWidth: '5%' },                   // ID
                    { sWidth: '40%' },                  // Email
                    { sWidth: '25%' },                  // Type
                    { sType: 'string', sWidth: '30%' }, // On - required for proper sorting of inline date data
                ],
                iDisplayLength: -1,
                noFilterKey: true
            });

            return;
        }

        _userDataTable = appn.dataTable.create(tableClass, {
            sDom: appn.dataTable.genSDom(0, 0, 0), // sDom empty
            paging: false,
            info: false,
            aaSorting: [[3, 'desc']],
            aoColumns: [
                { sWidth: '5%' },                   // ID
                { sWidth: '20%' },                  // Email
                { sWidth: '15%' },                  // Type
                { sType: 'string', sWidth: '20%' }, // On - required for proper sorting of inline date data
                { sType: 'string', sWidth: '20%' }, // Off - required for proper sorting of inline date data
                { sWidth: '20%' }                   // Off Reason
            ],
            iDisplayLength: -1,
            noFilterKey: true
        });
    }

    function reloadPage() {
        appn.location.navTo(_initArgs.billingBillableUsers, [
            { name: 'server', value: $('#serverFilter').val() },
            { name: 'year', value: $('#yearFilter').val() },
            { name: 'month', value: $('#monthFilter').val() },
            { name: 'showall', value: $('#ShowAllSelected').is(':checked') }
        ]);
    }

}
